import styled from 'styled-components';

export const CultivationImageInput = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  background: #fafafa;

  input[type=file] {
    display: none;
  }
`;